<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <Editor v-if="form.content" v-model="form.content" :defaultConfig="{ readOnly : true }" />
    <div slot="footer"></div>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import { Editor } from '@wangeditor/editor-for-vue'
export default {
  name: 'ShowRich',
  extends: BaseOpera,
  components: { GlobalAlertWindow, Editor },
  data () {
    return {
      // 表单数据
      form: {
        content: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/areas',
      'field.id': 'id'
    })
  },
  methods: {
   
  },
}
</script>
